<template>
  <div class="d-flex flex-column orders-collecting">
    <b-container class="flex-grow-1 d-flex flex-column h-100" fluid>
      <!-- User Interface controls -->
      <b-row class="flex-grow-1">
        <b-col md="3" class="d-flex flex-column h-100">
          <b-card no-body class="flex-grow-1" header-class="py-2" header="<b>Заказы:</b>">
            <div slot="header" class="d-flex justify-content-between align-items-center">
              <b>Заказы:</b>
              <span>
                <el-button class="no-outline" v-b-toggle.collapseOrders icon="el-icon-search" size="medium" circle></el-button>
              </span>
            </div>
            <b-collapse id="collapseOrders">
              <b-list-group flush>
                <b-list-group-item>
                  <b-form-group horizontal label="Поиск" class="mb-1">
                    <b-input-group>
                      <b-form-input v-model="filterOrders" placeholder="Введите № чека"/>
                      <b-input-group-append>
                        <b-btn :disabled="!filterOrders" @click="filterOrders = ''">Очистить
                        </b-btn>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                  <b-form-group horizontal label="Статус" class="mb-0">
                    <b-form-select v-model="filterStatus" :options="selectStatuses">
                      <option slot="first" :value="null">-- Все --</option>
                    </b-form-select>
                  </b-form-group>
                </b-list-group-item>
              </b-list-group>
            </b-collapse>
            <perfect-scrollbar class="flex-grow-1 flex-basis-0" :options="opsScroll">
              <b-list-group flush>
                <b-card-body class="text-center" v-if="orders.length === 0">Заказов не найдено
                </b-card-body>
                <b-list-group-item
                  v-for="ord in orders"
                  :key="ord.id"
                  :class="['order', {activeIt: selectedOrderId === ord.id}]"
                  @click="changeSelectedOrder(ord)"
                >
                  <order-block :order="ord" type="collector" :order-stages="orderStagesObj"></order-block>
                </b-list-group-item>
              </b-list-group>
            </perfect-scrollbar>
          </b-card>
        </b-col>
        <b-col md="9" class="d-flex flex-column">
          <b-card
            no-body
            class="flex-grow-1 d-flex flex-column"
            header-class="py-2"
            header="<b>Заказы:</b>"
          >
            <div slot="header" class="d-flex justify-content-between align-items-center">
              <b>Товары:</b>
              <b-btn v-if="selectedOrder && products.length" @click="printCheck()" variant="success">
                Напечатать чек ({{selectedOrder.timesPrinted + 1}})
              </b-btn>
            </div>
            <div v-if="!selectedOrderId"
                 class="flex-grow-1 text-center d-flex flex-column justify-content-center">
              <div>Сначала выберите заказ</div>
            </div>
            <perfect-scrollbar v-if="selectedOrderId" class="flex-grow-1" :options="opsScroll">
              <b-table
                @row-clicked="rowClicked"
                hover
                show-empty
                :empty-text="emptyTextProds"
                :fields="fields"
                :items="products"
                tbody-class="scroll-y"
                class="mb-0 table-orders"
                tbody-tr-class="order-prods"
              >
                <template #table-colgroup="scope">
                  <col
                    v-for="field in scope.fields"
                    :key="field.key"
                    :style="{ width: field.width || 'auto' }"
                  >
                </template>

                <template slot="accept" slot-scope="data">
                  <b-form-checkbox
                    v-if="!data.item.deleted"
                    :name="'accept' + data.item.id"
                    v-model="data.item.collected"
                    :value="true"
                    :unchecked-value="false">
                    собрано
                  </b-form-checkbox>
                </template>
                <template slot="cost" slot-scope="data">
                  {{data.item.cost > 0 ? data.item.cost + ' &#8381;' : data.item.pricePoints +
                  ' Б'}}
                </template>
                <template slot="nameProd" slot-scope="data">

                  <div :id="'orderProd' + data.item.index">
                    <div class="description">
                      {{`${brandsMap.get(data.item.idBrand)} - ${data.item.name}`}}
                    </div>
                    <b-badge
                      v-for="add in data.item.groupProds"
                      :key="add.id"
                      class="mr-1"
                    >
                      {{add.name}}{{add.cost > 0 ? ' (' + add.cost + ' &#8381;)' : ''}}
                    </b-badge>
                  </div>
                  <b-tooltip :target="'orderProd' + data.item.index" container="orderProd"
                             :title="data.item.description"></b-tooltip>
                </template>

                <template slot="countNum" slot-scope="data">
                  <span class="text-success h5">x {{data.item.count}} шт</span>
                </template>
              </b-table>
            </perfect-scrollbar>
            <div class="d-flex flex-shrink-0 justify-content-between">
              <b-btn
                class="flex-grow-1 ml-1  my-2"
                variant="danger"
                :disabled="!selectedOrderId"
                @click="cancelCollect()"
              >
                Не сохранять
              </b-btn>
              <b-btn
                class="flex-grow-1 ml-1  my-2"
                variant="success"
                :disabled="(!selectedOrderId || !permitChangeOrder) || !permitSave"
                @click="saveChangesCollect()"
              >
                Сохранить
              </b-btn>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import {
  COLLECTING_ORDERS_QUERY,
  PRODUCTS_QUERY,
  BRANDS_QUERY,
  ALL_PRODUCTS_QUERY,
  PRINT_INVOICE,
  STATUS_QUERY,
  BATCH_UPDATE_PRODUCT_COLLECTED,
  UPDATE_ORDER_COLLECTED
} from '@/constants/graphql'
import commonVar from '@/tempVariables/commonVars'
import {STATUS_ORDER} from '@/constants/keywords'
import lodash from 'lodash'

export default {
  name: 'OrdersCollecting',
  apollo: {
    allBrands: {
      query: BRANDS_QUERY,
      update (data) {
        data.allBrands.nodes.forEach(el => {
          this.brandsMap.set(el.id, el.name)
        })
      }
    },
    allProds: {
      query: ALL_PRODUCTS_QUERY,
      update (data) {
        let prods = data.allProducts.nodes
        prods.forEach(el => {
          this.prodsMap.set(el.id, el)
        })
        return prods
      }
    },
    statusOptions: {
      query: STATUS_QUERY,
      update (data) {
        let stages = data.allStageOrders.nodes
        this.selectStatuses = stages.map(el => {
          return {
            value: el,
            text: el.name
          }
        })
        this.filterStatus = this.selectStatuses.find((status) => status.value.keyword === 'cooked').value
        return stages
      }
    },
    products: {
      query: PRODUCTS_QUERY,
      fetchPolicy: 'network-only',
      skip () {
        return this.selectedOrderId === null
      },
      variables () {
        return {
          order: this.selectedOrderId || 0
        }
      },
      update (data) {
        let prods = data.allProductOrders.nodes
        if (prods.length > 1) {
          const fakeSort = Math.max(...prods.map(prod => prod.categoryByIdCategory.id)) * 10000
          prods.sort((a, b) => {
            const sort1 = a.categoryByIdCategory.sort || fakeSort
            const sort2 = b.categoryByIdCategory.sort || fakeSort
            const compare = sort1 - sort2
            
            if (0 === compare) {
              if (a.name === b.name) {
                return 0
              }

              return (a.name > b.name) ? 1 : -1
            }

            return compare
          })
        }
        prods.forEach(el => {
          if (el.idProduct) {
            let mainProd = this.prodsMap.get(el.idProduct)
            el.mainProd = mainProd
            el.name = this.getNameProduct(el)
          }
          if (el.deleted) {
            el._rowVariant = 'danger'
          }
          el.groupProds = []
          if (el.group !== null && el.group.length !== 0) {
            let subProds = el.group.split('|').map(item => parseInt(item))
            subProds.forEach((prodId, ind) => {
              el.groupProds.push(this.prodsMap.get(prodId))
            })
          }
        })
        return prods
      }
    },
    orders: {
      query: COLLECTING_ORDERS_QUERY,
      pollInterval: 10 * 1000,
      debounce: 500,
      variables () {
        let stageId = null
        if (!this.selectStatuses.length) {
          stageId = 7 // приготовлен
        } else if (this.filterStatus) {
          stageId = this.filterStatus.id
        }
        
        let dayId = null
        if (this.filterOrders) {
          dayId = parseInt(this.filterOrders)
        }
        
        return {
          stageId: stageId,
          dayId: dayId
        }
      },
      update (data) {
        if (data.ordersCollectingFiltered) {
          const orders = data.ordersCollectingFiltered.nodes          
          return orders.map(ord => {
            if (ord.statuses && ord.statuses.nodes) {
              ord.statuses.nodes.forEach(stage => {
                stage.stage = this.statusOptions.find(status => status.id === stage.idStageOrder)
              })
            }
            
            if (ord.idStage) {
              ord.status = this.statusOptions.find(status => status.id === ord.idStage)
            }
            
            return ord
          })
        }
        
        return []
      }
    }
  },
  data () {
    return {
      brandsMap: new Map(),
      filterOrders: '',
      fields: [
        {
          key: 'accept',
          label: 'Собрано',
          width: '100px'
        },
        {
          key: 'countNum',
          label: 'Кол-во',
          class: 'text-center',
          width: '150px'
        },
        {
          class: 'table-prod-name',
          key: 'nameProd',
          label: 'Товар'
        }
      ],
      permitSave: true,
      selectedOrder: null,
      selectStatuses: [],
      filterStatus: null,
      statusOptions: [],
      prodsMap: new Map(),
      emptyTextProds: 'Продукты не найдены',
      selectedOrderId: null,
      orders: [],
      products: [],
      opsScroll: commonVar.opsPerfectScroll
    }
  },
  computed: {
    permitChangeOrder () {
      return this.selectedOrder && this.selectedOrder.status.keyword !== STATUS_ORDER.CANCELED &&
          this.selectedOrder.status.keyword !== STATUS_ORDER.COLLECTED &&
          this.selectedOrder.status.keyword !== STATUS_ORDER.PASSED &&
          this.selectedOrder.status.keyword !== STATUS_ORDER.SENDED &&
          this.selectedOrder.status.keyword !== STATUS_ORDER.END
    },
    orderStagesObj () {
      return this.statusOptions.reduce((acc, item) => ({...acc, [item.id]: item}), {})
    }
  },
  methods: {
    getNameProduct (el) {
      let prod = this.prodsMap.get(el.idProduct)
      if (prod.pizzaSize === true || prod.burger === true) {
        if (prod.pizzaSize === true && el.smallSize === true) {
          return prod.name + ' + (на тонком тесте)'
        } else if (prod.burger === true) {
          if (el.smallSize === true) {
            return prod.name + ' + (свинина)'
          } else {
            return prod.name + ' + (говядина)'
          }
        } else return prod.name
      }
      return prod.name
    },
    printCheck () {
      this.$apollo.mutate({
        mutation: PRINT_INVOICE,
        variables: {
          idOrder: this.selectedOrderId
        }
      }).then(res => {
        this.selectedOrderId = null
        this.selectedOrder = null
      })
    },
    updateIndexProds () {
      let num = 1
      if (this.products != null) {
        this.products.forEach((prod) => {
          prod.index = num++
        })
      }
    },
    changeSelectedOrder (order) {
      this.selectedOrderId = order.id
      this.selectedOrder = order
    },
    cancelCollect () {
      this.selectedOrderId = null
      this.selectedOrder = null
    },
    confirmSave () {
      let permit = true
      this.products.forEach(prod => {
        permit &= prod.accepted
      })
      return permit
    },
    rowClicked (data) {
      if (!data.deleted) {
        data.collected = !data.collected
      }
    },
    clearSelectAndRefresh () {
      this.$apollo.queries.orders.refetch()
      this.selectedOrderId = null
      this.selectedOrder = null
    },
    saveChangesCollect () {
      this.permitSave = false
      try {
        const updateCollected = {
          true: [],
          false: []
        }
        let collectedAll = true
        
        this.products.forEach(prod => {
          collectedAll &= (prod.deleted || prod.collected)
          updateCollected[prod.collected].push(prod.id)
        })
        
        let mutations = []
        for (let collected in updateCollected) {
          if (updateCollected[collected].length) {
            mutations.push(
              this.$apollo.mutate({
                mutation: BATCH_UPDATE_PRODUCT_COLLECTED,
                variables: {
                  ids: updateCollected[collected],
                  collected: 'true' === collected // имя свойства - строка
                }
              })
            )
          }
        }
        
        Promise.all(mutations).then(res => {
          if (collectedAll) {
            this.$apollo.mutate({
              mutation: UPDATE_ORDER_COLLECTED,
              variables: {
                idOrder: this.selectedOrderId
              }
            }).then(res => {
              this.clearSelectAndRefresh()
            }).catch(err => {
              console.error(err)
              this.clearSelectAndRefresh()
            })
          } else {
            this.clearSelectAndRefresh()
          }
        })
      } catch (err) {

      } finally {
        this.permitSave = true
      }
    }
  },
  watch: {
    products () {
      this.updateIndexProds()
    }
  }
}
</script>

<style lang="scss" scoped>
  .orders-collecting {
  }
  .order {
    cursor: pointer;
    &:hover {
      background: #DBEAB4;
    }
    &.activeIt {
      background: #eeffc4;
    }
  }
  #collapseOrders {
    border-bottom: 1px solid #DFDFDF;
  }
</style>



// WEBPACK FOOTER //
// src/components/OrdersCollecting.vue